import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import ticket from './modules/ticket.js'
import restaurant from './modules/restaurant.js'
import hotel from './modules/hotel.js'
import general from './modules/general.js'
import marketing from './modules/marketing.js'
import concierge from './modules/concierge.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules:{
    ticket,
    restaurant,
    hotel,
    general,
    marketing,
    concierge
  },
  plugins: [createPersistedState()],
})



// WEBPACK FOOTER //
// ./src/store/index.js